import type { ConceptDef } from '../types';

export const intraverbalFillIn: ConceptDef = {
  kind: 'tileMatch',
  id: 'intraverbal-fill-in',
  label: 'Intraverbal Fill-In',
  category: 'Intraverbal',
  description: 'Hear a phrase with a missing word; tap the missing word.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'Twinkle twinkle little...', answer: '⭐ star' },
      { say: 'One, two,...', answer: '3 three' },
      { say: 'Ready, set,...', answer: '🏁 go' },
      { say: 'Knife and...', answer: '🍴 fork' },
      { say: 'Salt and...', answer: '🧂 pepper' },
      { say: 'Peanut butter and...', answer: '🍓 jelly' },
    ],
  },
};
